import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

import { VWTheme } from '../../../../shared/typings/vw-theme';

interface StyledGenericProps {
  theme: VWTheme;
  hasDescription: boolean;
}

export const StyledUserVehiclesAndServicesContainer: any = styled.div`
  ${({ theme }: StyledGenericProps) => {
    return `
			display: flex;
			flex-direction: column;
			gap: ${theme.size.static400};
			height: 100%;
			margin-top: ${theme.size.static400};

			@media (width: ${Breakpoints.b1920}px) {
				gap: ${theme.size.static500};
			}
		`;
  }}
`;

export const StyledInformationContainer: any = styled.div`
  width: 100%;
`;

export const StyledCardsContainer: any = styled.div`
  ${({ theme, hasDescription }: StyledGenericProps) => {
    return `
			align-self: stretch;
			display: grid;
			grid-template-columns: 1fr;
			padding-top: ${hasDescription ? theme.size.static350 : theme.size.static300};
			width: 100%;
			gap: ${theme.size.static250};

			@media(min-width: ${Breakpoints.b560}px) {
				grid-template-columns: repeat(auto-fill, minmax(366px, 1fr));
				gap: ${theme.size.static300};
			}

			@media(min-width: ${Breakpoints.b1920}px) {
				padding-top: ${hasDescription ? theme.size.static400 : theme.size.static350};
				gap: ${theme.size.static350};
				grid-template-columns: repeat(auto-fill, minmax(404px, 1fr));
			}
		`;
  }}
`;

export const StyledUserVehiclesContainer: any = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

export const StyledUserSubscriptionsContainer: any = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

export const StyledSpinnerContainer = styled.div`
  align-items: 'center';
  display: 'flex';
  justify-content: 'center';
  width: '100%';
`;
